declare var pm: PmInterface;

export default function setupDotsMenu() {
	const { getClosest } = pm.utils.dom;

	const notices = document.querySelectorAll(".dots-menu .submission-notice");

	document.addEventListener("click", handleDocumentClick);
	window.addEventListener("keydown", handleWindowKeydown);

	/**
	 * Function to run on document click event.
	 *
	 * @param e
	 */
	function handleDocumentClick(e: MouseEvent) {
		const target = e.target as HTMLElement | null;
		if (!target) return;

		const menu = getClosest(target, ".dots-menu", 10) as HTMLElement | null;

		if (menu) {
			if (menu.classList.contains("is-open")) {
				const clickedItem = getClosest(target, ".dots-menu-click", 10);

				if (clickedItem && clickedItem.classList.contains("close-on-click")) {
					closeDropdownMenu(menu);
				}
			} else {
				openDropdownMenu(menu);
			}
		} else {
			closeAllDropdownMenuExcept();
		}
	}

	/**
	 * Function to run on window keydown event.
	 *
	 * @param e
	 */
	function handleWindowKeydown(e: KeyboardEvent) {
		if (!e.key) return;
		const key = e.key.toLowerCase();

		if (key === "escape" || key === "esc") {
			closeAllDropdownMenuExcept();
		}
	}

	/**
	 * Open targetted dropdown menu.
	 *
	 * @param menu
	 */
	function openDropdownMenu(menu: HTMLElement) {
		pm.event.emit("dots_menu_open", { menu });

		if (notices) {
			notices.forEach(function (notice) {
				notice.classList.add("is-hidden");
				notice.textContent = "";
			});
		}

		closeAllDropdownMenuExcept(menu);
		menu.classList.add("is-open");
	}

	/**
	 * Close targetted dropdown menu.
	 *
	 * @param menu
	 */
	function closeDropdownMenu(menu: HTMLElement) {
		menu.classList.remove("is-open");
	}

	/**
	 * Close all dropdown menus with optional exclusion.
	 *
	 * If you want to exclude a menu from the process,
	 * then provide it as `menuToSkip`.
	 *
	 * @param menuToSkip
	 */
	function closeAllDropdownMenuExcept(menuToSkip?: HTMLElement) {
		const menus = document.querySelectorAll(
			".dots-menu",
		) as NodeListOf<HTMLElement>;
		if (!menus.length) return;

		menus.forEach(function (menu: HTMLElement) {
			if (menu === menuToSkip) return;
			closeDropdownMenu(menu);
		});
	}
}
